import React, { useEffect, useState } from 'react';
import { IconName, PopUp } from 'goalsetter-webapp-components';
import { useTranslation } from 'react-i18next';
import { RoutesGs } from 'router/RoutesList';
import { useNavigate } from 'react-router-dom';

interface LeaveFormModalProps {
  backRoute?: any;
}

export const LeaveFormModal: React.FC<LeaveFormModalProps> = ({
  backRoute,
}) => {
  const [showExitConfirmation, setShowExitConfirmation] =
    useState<boolean>(false);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const handleGoBack = () => {
    if (backRoute) {
      navigate(backRoute);
      return;
    }
    window.history.back();
  };

  const handleLeavePage = () => {
    setShowExitConfirmation(false);
    handleGoBack();
  };

  const handleStayOnPage = () => {
    setShowExitConfirmation(false);
  };

  const handlePopState = (event: PopStateEvent) => {
    event.preventDefault();
    setShowExitConfirmation(true);
  };

  useEffect(() => {
    window.history.pushState(null, window.location.pathname);
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [showExitConfirmation]);

  return (
    <PopUp
      isVisible={showExitConfirmation}
      icon={IconName.ATTENTION}
      iconSize={80}
      title={String(t('uhOh'))}
      description={String(t('leaveFormModalDescription'))}
      buttonPrimaryTitle={String(t('stay'))}
      buttonSecondaryTitle={String(t('leave'))}
      onPressPrimary={handleStayOnPage}
      onPressSecondary={handleLeavePage}
      onClose={handleStayOnPage}
    />
  );
};
